module.exports = __webpack_public_path__ + "static/media/rose_jam.67096c14.png";